import { render, staticRenderFns } from "./header.vue?vue&type=template&id=18f78ecd&scoped=true&"
var script = {}
import style0 from "./header.vue?vue&type=style&index=0&id=18f78ecd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f78ecd",
  null
  
)

export default component.exports